import { Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";

import { formatDate } from "~/modules/app/util/formatters";

import { STATUS_TO_TRANSLATION_KEY_MAP } from "../constants";
import { VisitStatusTimelineFragment } from "../fragment.generated";

type TimelineMessageProps = {
    plannerStatus: VisitStatusTimelineFragment["plannerStatus"];
    firstStartDate: Date;
    latestEndDate: Date;
};

export function TimelineMessage({ plannerStatus, firstStartDate, latestEndDate }: TimelineMessageProps) {
    const { t } = useTranslation("plannerV2");

    return (
        <Typography variant="body2">
            <Trans
                t={t}
                i18nKey={STATUS_TO_TRANSLATION_KEY_MAP[plannerStatus]}
                values={{
                    formattedFirstStartDate: formatDate(firstStartDate, "long"),
                    formattedLatestEndDate: formatDate(latestEndDate, "long"),
                }}
                components={{ bold: <strong /> }}
            />
        </Typography>
    );
}
